import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '../_shared/services/Http.service';

@Injectable()
export class CommonHttpService extends HttpService {

 constructor(http: HttpClient) {
   super(http);
  }  
}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/commonHttp.service.ts